/**
 * Rateio de parcelas em CENTAVOS — espelho fiel do `SplitInstallments` do
 * backend (ERPApi, financial_calc.go): parcela comum = floor(total/n) e TODO o
 * resto de centavos vai na PRIMEIRA parcela (o mesmo comportamento da Cielo).
 *
 * A tela usa isto para manter os três campos (valor total, quantidade e valor
 * da parcela) sincronizados; o payload enviado à API continua sendo o total.
 */

/** Converte o texto do input ("1.234,56" ou "1234.56") para centavos. */
export const toCents = (value: string): number | null => {
  const parsed = parseFloat(value.replace(',', '.'));
  if (isNaN(parsed) || parsed < 0) return null;
  return Math.round(parsed * 100);
};

/** Converte centavos para o formato aceito pelo input numérico ("1234.56"). */
export const centsToInput = (cents: number): string => (cents / 100).toFixed(2);

/**
 * Divide o total em n parcelas: `base` é a parcela comum e `first` é a
 * primeira, que leva o resto (first >= base sempre).
 */
export const splitInstallments = (totalCents: number, n: number): { base: number; first: number } => {
  if (n <= 1) return { base: totalCents, first: totalCents };
  const base = Math.floor(totalCents / n);
  return { base, first: totalCents - base * (n - 1) };
};

/** Total a partir do valor da parcela: parcela × n, exato (sem resto). */
export const totalFromInstallment = (installmentCents: number, n: number): number =>
  installmentCents * Math.max(1, n);
